import React from 'react';
import { RouteProp } from '@react-navigation/native';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { Form } from '../../../../v2BaseComponents/Form';
import { getIntl } from '../../../../../utils/intl';
import UseOrganizationClientRecordBillingDetails from '../../../../../hooks/api/useOrganizationClientRecordBillingDetails';
import EditClientBillingInfoFields, {
    FormValue,
    getDefaultFormValue,
    formValueToCreateClientRecordInvitationRequest,
} from '../../../../shared/EditClientBillingInfo/EditClientBillingInfoFields';

const intl = getIntl('profiles.editClientBillingInfoScree', {
    update: 'Update',
});

export type EditClientBillingInfoScreenOwnProps = {};

export type EditClientBillingInfoScreenNavigatorProps = {
    route: RouteProp<ProfilesTabParamList, 'edit-client-billing-info'>;
};

const emptyBillingDetails: FormValue = {
    name: '',
    email: '',
    phoneNumber: '',
};

export type EditClientBillingInfoScreenProps = EditClientBillingInfoScreenOwnProps &
    EditClientBillingInfoScreenNavigatorProps;

const EditClientBillingInfoScreen: React.FC<EditClientBillingInfoScreenProps> = ({ route }) => {
    const goBack = useGoBack();
    const { isLoadingBillingDetails, isUpdatingBillingDetails, updateBillingDetails, billingDetails } =
        UseOrganizationClientRecordBillingDetails({
            organizationClientRecordId: route.params.clientRecordId,
            onUpdatedBillingDetails: goBack,
        });

    return (
        <AnimateLoadedContent
            isLoading={isLoadingBillingDetails || isUpdatingBillingDetails || !billingDetails}
            key={JSON.stringify(billingDetails)}
        >
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={billingDetails ? getDefaultFormValue(billingDetails) : emptyBillingDetails}
                    onSubmit={(values) => {
                        const request = formValueToCreateClientRecordInvitationRequest(values);
                        updateBillingDetails(request);
                    }}
                    onCancel={goBack}
                    saveText={intl('update')}
                    saveIcon="CheckCircle"
                >
                    {() => <EditClientBillingInfoFields />}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditClientBillingInfoScreen);
